import { render, staticRenderFns } from "./CablePricesEdit.vue?vue&type=template&id=8f62fcb0&scoped=true&"
import script from "./CablePricesEdit.vue?vue&type=script&lang=js&"
export * from "./CablePricesEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f62fcb0",
  null
  
)

export default component.exports